export enum DataSchemaFieldRowPages {
  InputDefinition = 'input-definition',
  OutputDefinition = 'output-definition',
  DataStore = 'data-store',
  DataEvent = 'data-event',
  ModelField = 'model-field',
  UserGenerated = 'user-generated' // to display user generated data schemas in data schema list
}
